type CqsBook = {
  id?: string
  cqs_enabled?: boolean | null
}

const readCqsEnabledFlag = (book?: CqsBook | null): boolean | null => {
  if (!book || typeof book.cqs_enabled !== 'boolean') {
    return null
  }

  return book.cqs_enabled
}

// The tab stays hidden until the chapter request has finished.
// It appears only when that response says content questions are on.
export const resolveCqsEnabled = (
  originalBooks: CqsBook[] = [],
  originalBookId: string,
  loadState?: string
): boolean | null => {
  if (loadState !== 'done') {
    return null
  }

  return readCqsEnabledFlag(
    originalBooks.find(book => book.id === originalBookId)
  )
}
